export interface PropertyProvenance {
  attributes_source?: string | null;
  attributes_updated_at?: string | null;
  attributes?: Record<string,unknown> | null;
}
export function factProvenance(property:PropertyProvenance,key:string) {
  const evidence=property.attributes?._evidence;
  const quote=evidence && typeof evidence==='object' && !Array.isArray(evidence) ? (evidence as Record<string,unknown>)[key] : null;
  let url:string|null=null;
  try { const parsed=new URL(property.attributes_source || ''); if(['https:','http:'].includes(parsed.protocol)) url=parsed.href; } catch {}
  return {url,quote:typeof quote==='string'?quote:null,recordedAt:property.attributes_updated_at || null};
}
export function googleReviewsUrl(property:{name:string;address?:string|null}) {
  const url=new URL('https://www.google.com/maps/search/');
  url.searchParams.set('api','1');
  url.searchParams.set('query',[property.name,property.address].filter(Boolean).join(' '));
  return url.toString();
}
